import { defineComponent as _defineComponent } from 'vue'
import {
  computed, onMounted, PropType, ref, toRefs
} from 'vue';
import { kebabCase } from 'lodash';
import useMultiLineBreaks from '@/mixins/useMultiLineBreaks';
import useI18n from '@/mixins/useI18n';
import { useMediaQuery, useResizeObserver, useWindowSize } from '@vueuse/core';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import asyncWait from '@/utils/asyncWait';
import LPAccordionItem from './LPAccordionItem.vue';
import LPButton from './LPButton.vue';

export interface AccordionItem {
  title: string;
  text: string;
  icon: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LPAccordion',
  props: {
  title: {
    type: String,
    required: true
  },
  accordionItems: {
    type: Array as PropType<AccordionItem[]>,
    required: true
  },
  openMultiple: {
    type: Boolean,
    required: false,
    default: false
  },
  initialOpen: {
    type: Array as PropType<number[]>,
    required: false,
    default: () => []
  },
  showFooter: {
    type: Boolean,
    required: false,
    default: true
  }
},
  setup(__props) {

const props = __props;



const {
  title, accordionItems, initialOpen, openMultiple
} = toRefs(props);

const { t } = useI18n();
const isMobile = useMediaQuery('(width < 800px)');
const { width: screenWidth } = useWindowSize();
const accordionItemsRef = ref<Array<InstanceType<typeof LPAccordionItem>> | null>(null);

// eslint-disable-next-line no-nested-ternary
const lineBreak = computed(() => (isMobile.value ? 'narrow' : 'wide'));
const linebreaks = t('landingpage-customer.linebreaks') as any;
const { tl } = useMultiLineBreaks(linebreaks, lineBreak);

const openItems = ref<number[]>([]);

const openItem = async (index: number) => {
  if (!accordionItems.value[index]) return;
  if (openItems.value.includes(index)) {
    openItems.value = openItems.value.filter((i) => i !== index);
  } else if (!openMultiple.value) {
    if (openItems.value.length > 0) {
      openItems.value = [];
      await asyncWait(250);
      openItems.value = [index];
    } else {
      openItems.value = [index];
    }
  } else {
    openItems.value = [...openItems.value, index];
  }
};

const headerWidths = ref<number[]>([0]);

const maxHeaderWidth = computed(() => {
  if (!headerWidths.value.length) return 0;
  const maxWidth = Math.ceil(Math.max(...headerWidths.value));

  if (isMobile.value && maxWidth > screenWidth.value) {
    return screenWidth.value - 16;
  }
  return maxWidth;
});

const closeItem = (index: number) => {
  openItems.value = openItems.value.filter((i) => i !== index);
};

onMounted(() => {
  if (Array.isArray(initialOpen.value)) {
    initialOpen.value.forEach((i) => openItem(i));
  } else if (initialOpen.value >= 0) {
    openItem(initialOpen.value);
  }
  accordionItemsRef.value?.forEach((item) => {
    const headline = item.$refs.accordionItemHeadline as HTMLElement;
    useResizeObserver(headline, (entries) => {
      const [entry] = entries;
      headerWidths.value.push(entry.contentRect.width);
    });
  });
});

return { __sfc: true,props, title, accordionItems, initialOpen, openMultiple, t, isMobile, screenWidth, accordionItemsRef, lineBreak, linebreaks, tl, openItems, openItem, headerWidths, maxHeaderWidth, closeItem, kebabCase, BCXMarkdown, LPAccordionItem, LPButton }
}

})